import './columns4.less'

import React from 'react'
import {WysiwygType} from 'types'
import {style} from 'util/style'
import {Column, Grid} from 'views/layout/grid'
import {Title} from 'views/layout/title'
import {Theme} from 'views/theme'

const styles = style('columns4', ['item'])

export type Columns4Type = {
	title?: string
	subtitle?: string
	text?: WysiwygType
	items: Array<Columns4ItemType>
	visibleIndex?: boolean
}

export type Columns4ItemType = {
	title: string
	text?: WysiwygType
}

export const Columns4: React.FC<Columns4Type> = ({
	title,
	subtitle,
	text,
	items,
	visibleIndex
}) => {
	const itemsLengthThree = items.length >= 3 ? 3 : items.length
	const itemsLengthFour = items.length >= 4 ? 4 : items.length
	return (
		<div className={styles()}>
			<Theme.Container>
				<div className={styles('top')}>
					<Title title={title} subtitle={subtitle} />
					<div className={styles('top-text')}>
						<Theme.Wysiwyg>{text}</Theme.Wysiwyg>
					</div>
				</div>
				<div className={styles('items')}>
					<Grid
						columns={1}
						s={2}
						m={itemsLengthThree}
						l={itemsLengthFour}
						xl={itemsLengthFour}
						xxl={itemsLengthFour}
					>
						{items.map((item, index) => (
							<Column key={index}>
								<Columns4Item
									{...item}
									index={index}
									visibleIndex={visibleIndex}
								/>
							</Column>
						))}
					</Grid>
				</div>
			</Theme.Container>
		</div>
	)
}

export const Columns4Item: React.FC<Columns4ItemType & {
	index: number
	visibleIndex?: boolean
}> = ({title, text, index, visibleIndex = true}) => (
	<div className={styles.item()}>
		{visibleIndex && <div className={styles.item('number')}>{index + 1}</div>}
		{title && <Theme.H4 className={styles.item('title')}>{title}</Theme.H4>}
		{text && (
			<div className={styles.item('text')}>
				<Theme.Wysiwyg>{text}</Theme.Wysiwyg>
			</div>
		)}
	</div>
)
